"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Selector = _interopRequireDefault(require("../../Common/Selector"));
var _DatePicker = _interopRequireDefault(require("../../../DatePicker"));
var _excluded = ["value"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var StyledOption = _Selector["default"].StyledOption;
var StyledButton = _DatePicker["default"].StyledButton;
var StyledDatePicker = (0, _styledComponents["default"])(_DatePicker["default"]).withConfig({
  displayName: "TicketFilterByDate__StyledDatePicker",
  componentId: "sc-18su1xp-0"
})(["", "{background-color:transparent;border:1px solid #e6e9ee;border-radius:4px;height:43px;}", "{padding:3px 10px 7px 10px;}"], StyledButton, StyledOption);
var TicketFilterByDate = /*#__PURE__*/function (_React$PureComponent) {
  function TicketFilterByDate(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TicketFilterByDate);
    _this = _callSuper(this, TicketFilterByDate, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(TicketFilterByDate, _React$PureComponent);
  return (0, _createClass2["default"])(TicketFilterByDate, [{
    key: "handleChange",
    value: function handleChange(value) {
      var _this$props = this.props,
        onChange = _this$props.onChange,
        name = _this$props.name;
      onChange({
        name: name,
        value: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        value = _this$props2.value,
        props = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      return /*#__PURE__*/_react["default"].createElement(StyledDatePicker, (0, _extends2["default"])({}, props, {
        multiple: true,
        required: false,
        key: value,
        value: value,
        dateFormat: "d MMMM",
        onChange: this.handleChange
      }));
    }
  }]);
}(_react["default"].PureComponent);
TicketFilterByDate.propTypes = {
  className: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].arrayOf(_propTypes["default"].shape())
};
TicketFilterByDate.defaultProps = {
  className: '',
  name: '',
  onChange: Function.prototype,
  value: null
};
var _default = exports["default"] = TicketFilterByDate;